import { Pipe, PipeTransform } from '@angular/core'
import { TargetEntityType, TaskLog } from '../store/task-log/task-log.state'
import { User } from '../store/auth/auth.state'
import { LOG_MESSAGE_REGISTRY } from '../logging/log-message-registry'
import { getLinkForEntity, smartDefaultGenerator } from '../logging/smart-default-generator'
import { LogMessageSegment } from '../logging/log-message-registry.model'

@Pipe({
  name: 'generateLogMessage'
})
export class GenerateLogMessagePipe implements PipeTransform {
  // transform(log: TaskLog, currentUser: User | null): LogMessageSegment[] {
  //   if (!log || !currentUser) {
  //     return []
  //   }

  //   // 1. Look for a hand-crafted, specific generator first.
  //   const specificGenerator = LOG_MESSAGE_REGISTRY[log.actionType]

  //   // 2. If it exists, use it. Otherwise, use the smart default.
  //   if (specificGenerator) {
  //     return specificGenerator(log)
  //   } else {
  //     return smartDefaultGenerator(log)
  //   }
  // }

  //25 march 2026 gps
  // transform(log: TaskLog, currentUser: User | null): LogMessageSegment[] {
  //   if (!log || !currentUser) return []

  //   // ✅ 1. Use backend segments if available
  //   if (log.segments && log.segments.length) {
  //     return log.segments.map(seg => ({
  //       text: seg.text ?? '',
  //       // convert "/employees/123" → ['employees','123']
  //       link: seg.link ? this.convertToRouterLink(seg.link) : undefined
  //     }))
  //   }

  //   // ✅ 2. Use specific generator if exists
  //   const specificGenerator = LOG_MESSAGE_REGISTRY[log.actionType]
  //   if (specificGenerator) {
  //     return specificGenerator(log)
  //   }

  //   // ✅ 3. fallback
  //   return smartDefaultGenerator(log)
  // }

  transform(log: TaskLog, currentUser: User | null): LogMessageSegment[] {
    if (!log || !currentUser) return []

    if (log.segments?.length) {
      return log.segments.map(seg => {
        let routerLink: string[] | undefined

        if (seg.link) {
          const { entityType, entityId } = this.parseEntityFromLink(seg.link)

          if (entityType && entityId) {
            routerLink = getLinkForEntity(entityType, entityId)
          }
        }

        return {
          text: seg.text ?? '',
          link: routerLink
        }
      })
    }

    const specificGenerator = LOG_MESSAGE_REGISTRY[log.actionType]
    if (specificGenerator) return specificGenerator(log)

    return smartDefaultGenerator(log)
  }

  private convertToRouterLink(link: string): string[] {
    return ['/', ...link.split('/').filter(Boolean)]
  }

  parseEntityFromLink(link: string): {
    entityType: TargetEntityType | null
    entityId: string | null
  } {
    const parts = link.split('/').filter(Boolean)

    if (!parts.length) {
      return { entityType: null, entityId: null }
    }

    switch (parts[0]) {
      case 'employees':
        return { entityType: TargetEntityType.EMPLOYEE, entityId: parts[1] }

      case 'business':
        return { entityType: TargetEntityType.BUSINESS, entityId: parts[1] }

      case 'roles':
        return { entityType: 'ROLE' as any, entityId: parts[1] }

      default:
        return { entityType: null, entityId: null }
    }
  }
}
